import { IAxToastOptions } from "./ax-toast-type";
import AxToast from "./ax-toast";

export default class AxToastsController {
  private toastsContainer: HTMLDivElement;

  public constructor() {
    this.toastsContainer = document.createElement("div");
    this.toastsContainer.className = "ax-toasts-container";
    
  }

  public show(option: IAxToastOptions) {  
    const toast = new AxToast(option);
      document.body.appendChild(this.toastsContainer)

    if (option.autoDismissAfter) {
      setTimeout(() => {
        toast.close();
      }, option.autoDismissAfter + 500);
    }

    if (this.toastsContainer.childElementCount < 1) {
      this.toastsContainer.className = "ax-toasts-container";
      this.toastsContainer.style.zIndex = "19999";
    }

    this.toastsContainer.appendChild(toast.toastElement);

    setTimeout(() => {
      toast.toastElement.classList.add("ax-toast__open");
    }, 1);
  }

  public showToastsContainer() {
    return this.toastsContainer;
  }

  public close(toast: HTMLDivElement) {
    this.toastsContainer.removeChild(toast);
  }
}
